import { Icon, ICONS } from '@bob/library'
import { useBasketApi } from '@websrc/Basket/useBasketApi'
import { useBasketStateOptional } from '@websrc/Basket/useBasketState'
import React from 'react'

import * as SC from './QuoteNumber.style'

export interface QuoteNumberProps {
  hideRemove?: boolean
}

export function QuoteNumber({ hideRemove }: QuoteNumberProps) {
  const basketState = useBasketStateOptional()
  const basketApi = useBasketApi()

  if (!basketState) return null

  const { quoteId } = basketState.meta

  if (!quoteId) return null

  const handleRemoveQuote = () => {
    // delete basket and get a new one
    void basketApi(``, 'DELETE').then(() => basketApi(``, 'POST'))
  }

  return (
    <SC.QuoteNumberWrapper>
      {!hideRemove && (
        <SC.ClearQuote onClick={handleRemoveQuote} title={'Remove Quote'}>
          <Icon icon={ICONS.CROSS} size={14} />
        </SC.ClearQuote>
      )}
      <span>Quote number: {quoteId}</span>
    </SC.QuoteNumberWrapper>
  )
}
